module.exports = __webpack_public_path__ + "static/media/districamp.2e9582e2.png";